import {Component, Input, OnInit} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '../../../core/services/utility.service';
import {from, Observable, of, Subject} from "rxjs";
import {debounceTime, distinctUntilChanged, switchMap, tap} from "rxjs/operators";

@Component({
  selector: 'app-search-select-modal',
  templateUrl: './search-select-modal.component.html',
  styleUrls: ['./search-select-modal.component.css']
})
export class SearchSelectModalComponent  implements OnInit{
  @Input() bindLabel: string;
  @Input() bindValue: string;
  @Input() headerText: any;
  @Input() clearButtonText: string = 'Clear Value';
  @Input() saveButtonText: string = 'Save';
  @Input() cancelButtonText: string = 'Cancel';
  @Input() searchFunction: (args: string) => any[] | null = null;
  @Input() searchFunctionAsync: (args: string) => Promise<any[]> | null = null;
  @Input() minTermLength: number = 3;
  items$: Observable<any[]> = new Observable();
  @Input() selectedItem: any = null;
  @Input() placeholder: string = 'Type to search...';
  typeahead$ = new Subject<string>();
  cleared: boolean = false;

  constructor(
    private ngbActiveModal: NgbActiveModal,
    public utilityService: UtilityService
  ) { }

  ngOnInit() {
    this.loadItems();
  }

  setCleared(){
    this.cleared = true;
  }

  clearSearchField() {
    this.selectedItem = null;
    this.saveAndCloseModal();
  }

  saveAndCloseModal () {
    this.ngbActiveModal.close(this.selectedItem);
  };

  cancelAndCloseModal () {
    this.ngbActiveModal.close(undefined);
  };

  private loadItems() {
    this.items$ = this.typeahead$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((term) => {
          if(this.searchFunction != null){
            return of(this.searchFunction(term));
          }
          if(this.searchFunctionAsync != null){
            return from(this.searchFunctionAsync(term))
          }

          throw new Error("No available search functionality");
        }
      ),
    );
  }
}
